import { Avatar, Box, Button, Flex, Image, Td, Text, Tr, useBoolean } from '@chakra-ui/react'
import type { InsuranceParamsGridItem, InsuranceParamsVehicleGridItem } from 'BrokerTsLib/src/dtos'
import { formatPersonFullName } from 'BrokerTsLib/src/dtos'
import { Product, SelectionType } from 'brokertslib/src/enums'
import { Link, useNavigate } from 'react-router-dom'

import { useSelections } from '../../hooks'
import { useApp } from '../../hooks/useApp'
import { Contract } from '../../icons'
import { getLogo } from '../../utils/companiesLogos'
import { formatDate } from '../../utils/formatDate'
import { Subject } from '../Subject'

export const ContractRow = ({ item }: { item: InsuranceParamsGridItem }) => {
  const navigate = useNavigate()
  const { product } = useApp()
  const [buttonsVisible, setButtonsVisible] = useBoolean(false)

  const { data: dataCat } = useSelections(SelectionType.FormaSjednani, { enabled: product !== Product.TravelInsurance })
  const logo = item.insurerId ? getLogo(item.insurerId!) : null
  const insureeName = formatPersonFullName(item.policyHolder)

  let vehicleItem: InsuranceParamsVehicleGridItem | null = null
  if ([Product.VehicleInsurance, Product.VehicleLeasingInsurance].includes(product!))
    vehicleItem = item as InsuranceParamsVehicleGridItem

  const subject = `${vehicleItem?.vehicle?.znacka ?? ''} ${vehicleItem?.vehicle?.model ?? ''}`.trim()

  let navigateTarget: string
  switch (product) {
    case Product.TravelInsurance:
      navigateTarget = `/cestovko/wizard/${item.step ?? 1}/${item.insuranceParamsId}`
      break
    case Product.PropertyInsurance:
    case Product.LiabilityInsurance:
      navigateTarget = `/chaloupka/wizard/${item.step ?? 1}/${item.insuranceParamsId}`
      break
    default:
      navigateTarget = `/carkulka/wizard/${item.step ?? 1}/${item.insuranceParamsId}`

      if (item.type === 2)
        navigateTarget = `/carkulka/extra/wizard/${item.step ?? 1}/${item.insuranceParamsId}`

      break
  }


  return (
    <Tr onMouseEnter={setButtonsVisible.on} onMouseLeave={setButtonsVisible.off} textDecoration={item.contractCanceled ? 'line-through' : 'none'}>
      <Td>
        <Box className="contract__id-progress-note">
          <Box className="contract__id-progress">
            <Link to={navigateTarget}>
              <Text sx={{ color: 'primary.400', fontSize: 'xl', fontWeight: 'semibold' }}>{item.contractNumber}</Text>
            </Link>
          </Box>
        </Box>
      </Td>

      <Td>
        <Text fontSize='sm'>{item.insuranceParamsId}/{item.offerId}</Text>
      </Td>

      <Td>
        {item.startDate && (
          <Text sx={{ fontSize: 'sm', fontWeight: 'semibold' }}>
            {formatDate({ date: item.startDate })}
          </Text>
        )}
        {item.contractCreatedDate && <Text sx={{ fontSize: 'sm' }}>{formatDate({ date: item.contractCreatedDate })}</Text>}
      </Td>

      <Td sx={{ px: 0, w: 10 }}>
        {insureeName && <Avatar size="sm" colorScheme="primary" name={insureeName.trim()} />}
      </Td>

      <Td sx={{ pl: 0 }}>
        {insureeName && <Text sx={{ fontSize: 'sm' }}>{insureeName}</Text>}
        {!!subject && <Subject>{subject}</Subject>}
      </Td>

      <Td>
        <Image src={logo!} alt={item.insurerFullName} width="64px" maxH="48px" />
      </Td>

      {product !== Product.TravelInsurance && (
        <Td>
          <Text sx={{ fontSize: 'sm' }}>{dataCat?.find(x => x.value?.toString() == item.contractAcceptationType?.toString())?.description}</Text>
        </Td>
      )}

      <Td>
        <Flex
          sx={{ gap: 1, placeContent: 'end', visibility: buttonsVisible ? 'visible' : 'hidden' }}
        >
          <Button variant="outline" size="sm" onClick={() => navigate(navigateTarget)}>
            <Contract color="secondary.500" />
            Zobrazit
          </Button>
          {/* <Button size="sm" variant="ghost">
            Napsat klientovi
          </Button> */}
        </Flex>
      </Td>
    </Tr>
  )
}
